<template>
    <div style="margin-top: 25px">
        <el-row>
            <el-col :span="24">
                <div class="prefill-wrapper">
                    <btn icon="fas fa-file-import"
                         :disabled="employer_id === null"
                         :click="() => dialogPrefillFromJob = true">
                        Pre-fill from job
                    </btn>
                    <btn icon="fas fa-file-import"
                         :disabled="employer_id === null"
                         :click="() => dialogPrefillFromCampaign = true">
                        Pre-fill from campaign
                    </btn>
                    <p style="margin-bottom:8px"><b>Pre-fill values according to campaign or job</b></p>
                    <p v-if="employer_id !== null">Select a campaign or a job to fill in: location, experience levels and categories.</p>
                    <p v-else class="text-danger">Select an employer first.</p>
                </div>
            </el-col>
        </el-row>

        <QuotePrefillFromCampaign
            :employer_id="employer_id"
            :show="dialogPrefillFromCampaign"

            @prefill="(d) => $emit('prefill', d)"
            @close="dialogPrefillFromCampaign = false"
        ></QuotePrefillFromCampaign>

        <QuotePrefillFromJob
            :employer_id="employer_id"
            :show="dialogPrefillFromJob"

            @prefill="(d) => $emit('prefill', d)"
            @close="dialogPrefillFromJob = false"
        ></QuotePrefillFromJob>
    </div>
</template>

<script>
import QuotePrefillFromJob from './dialogs/quote-prefill-from-job';
import QuotePrefillFromCampaign from './dialogs/quote-prefill-from-campaign';

export default {
    props: [
        'employer_id',
    ],
    components: {
        QuotePrefillFromJob,
        QuotePrefillFromCampaign,
    },
    data() {
        return {
            dialogPrefillFromCampaign: false,
            dialogPrefillFromJob: false,
        };
    },
};
</script>

<style scoped>

</style>